import { PageHeader } from '../../components/PageHeader';
import { useDict } from '../../i18n/dictionary';
import { useLocale } from '../../lib/locale';
import { usePageTitle } from '../../lib/page';
import { libraryDict } from './i18n';
import { StoryCards } from './StoryCards';
import { storiesOf } from './stories';

/** The components section on its own — where the phone tab bar lands. */
export function LibraryComponentList() {
  const t = useDict(libraryDict);
  const { locale } = useLocale();
  usePageTitle(t.componentsTitle);

  return (
    <>
      <PageHeader title={t.components} />
      <StoryCards entries={storiesOf('component', locale)} />
    </>
  );
}
